import React, {PureComponent, ReactNode} from "react"
import {Tab as RbTab} from "react-bootstrap"

import Spacing from "../Spacing"
import Headers from "./Headers"
import StyledHr from "./styled/Hr"

export interface Tab {
  title: string,
  key: string,
  component: ReactNode
}

export interface Props {
  id: string,
  tabs: Tab[],
  activeKey?: string|null,
  onSelect?: (selection: any) => void,
  fullWidth?: boolean,
  mountOnEnter?: boolean,
  unmountOnExit?: boolean,
  activeHeaderColor?: string,
  className?: string|null,
  addMarginTop?: boolean
}

export default class Tabs extends PureComponent<Props> {
  static defaultProps = {
    activeKey: null,
    onSelect: () => {},
    fullWidth: false,
    mountOnEnter: false,
    unmountOnExit: false,
    activeHeaderColor: undefined,
    className: null,
    addMarginTop: false
  }

  render() {
    const {tabs, id, fullWidth, onSelect, activeKey, mountOnEnter, unmountOnExit, activeHeaderColor, className, addMarginTop} = this.props
    const defaultActiveKey = activeKey || tabs[0].key

    return (
      <RbTab.Container id={id} defaultActiveKey={defaultActiveKey} onSelect={onSelect} className={className}>
        <div>
          <Headers tabs={tabs} fullWidth={fullWidth} activeColor={activeHeaderColor} />
          <StyledHr />
          {addMarginTop && <Spacing marginTop={4} />}
          <RbTab.Content mountOnEnter={mountOnEnter} unmountOnExit={unmountOnExit}>
            {tabs.map(({key, component}) => (
              <RbTab.Pane key={key} eventKey={key}>
                {component}
              </RbTab.Pane>
            ))}
          </RbTab.Content>
        </div>
      </RbTab.Container>
    )
  }
}
